/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments200,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments401,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments404,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments500,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocumentsPathParams,
  GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocumentsQueryResponse,
} from "../../types/courseRegistrationDocumentApprovalController/GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments.ts";
import { courseRegistrationManagementAttachmentGroupViewModelSchema } from "../courseRegistrationManagementAttachmentGroupViewModelSchema.ts";

export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocumentsPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocumentsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments200Schema =
  z.array(
    z.lazy(() => courseRegistrationManagementAttachmentGroupViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments500>;

export const getApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocumentsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocuments200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationDocumentApprovalCourseregistrationidOtherDocumentsQueryResponse>;
